const onLoadScroll = (offset) => {
  const urlHash = window.location.hash.substring(1)
  if (!urlHash) return

  const targetSection = document.getElementById(urlHash)
  if (targetSection && window.lenis) {
    window.lenis.scrollTo(targetSection, {
      offset,
      duration: 1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    })
  }
}

const internalAnchorLinks = (offset) => {
  const anchorLinks = document.querySelectorAll('a[href^="#"]')
  anchorLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault()

      const target = document.getElementById(
        link.getAttribute("href").substring(1)
      )

      if (target && window.lenis) {
        window.lenis.scrollTo(target, {
          offset,
          duration: 1,
          easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        })
      }
    })
  })
}

export const handleAnchorScroll = (offset = -40) => {
  onLoadScroll(offset)
  internalAnchorLinks(offset)
}
